import { render, staticRenderFns } from "./ManageAccount.vue?vue&type=template&id=6b706d7a&scoped=true&"
import script from "./ManageAccount.vue?vue&type=script&lang=js&"
export * from "./ManageAccount.vue?vue&type=script&lang=js&"
import style0 from "./ManageAccount.vue?vue&type=style&index=0&id=6b706d7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b706d7a",
  null
  
)

export default component.exports